export default __webpack_public_path__ + "static/garden_design20-e755bd4e1bb0ac9fc5b85f6cfad36803.webp";